import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Zap } from "lucide-react";

export const SnapMenu = ({ leadId, team = [], onDone, variant = "outline", size = "sm", label = "SNAP", className = "" }) => {
  const [busy, setBusy] = useState(false);

  const snap = async (m) => {
    setBusy(true);
    try {
      await api.post(`/leads/${leadId}/snap`, { user_id: m.user_id });
      toast.success(`Snapped exclusively to ${m.name} — they've been notified`);
      onDone && onDone();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const autoSnap = async () => {
    setBusy(true);
    try {
      await api.post(`/leads/${leadId}/snap-auto`);
      toast.success("Auto-snapped to the next agent in rotation — notified");
      onDone && onDone();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} disabled={busy} className={className}
          data-testid={`snap-button-${leadId}`} onClick={(e) => e.stopPropagation()}>
          <Zap className="mr-1.5 h-4 w-4" /> {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()} className="w-56">
        <DropdownMenuItem onClick={autoSnap} data-testid={`snap-auto-${leadId}`}>
          <Zap className="mr-2 h-4 w-4 text-primary" /> Next agent (round-robin)
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Snap exclusively to…</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {team.length === 0 && <div className="px-2 py-1.5 text-xs text-muted-foreground">No teammates available</div>}
        {team.map((m) => (
          <DropdownMenuItem key={m.user_id} onClick={() => snap(m)} data-testid={`snap-agent-${m.user_id}`}>
            {m.name} <span className="ml-2 text-xs capitalize text-muted-foreground">{m.role}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
